import api from "../config/apiConfig";
import { getUserDetails } from "../utils/auth";
import { getRegisterId } from "../utils/authId";

export const viewAllCompany = async () => {
  const id = getRegisterId();
  const user = getUserDetails() || {};

  try {
    const response = await api.get(
      `api/get_company/?admin_id=${id}&other_user=${user.role}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAllCompany = async () => {
  const id = getRegisterId() || {};
  const user = getUserDetails() || {};
  try {
    const response = await api.get(
      `api/get_company_group_channel/?register_id=${id}&other_user=${user.role}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAllAccessUser = async () => {
  const id = getRegisterId() || {};
  try {
    const response = await api.get(
      `api/staff_details_using_accessuser/?admin_id=${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUser = async (data) => {
  try {
    const response = await api.get(`api/get_company_select_emp/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAccessCompany = async (data) => {
  try {
    const respone = await api.get(
      `api/company_details_using_accessuser/${data}`
    );
    return respone.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSelectedPeople = async (data) => {
  try {
    const response = await api.get(`api/identify_active_deactive/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLoginuser = async () => {
  const id = getRegisterId();
  const fcmToken = getUserDetails() || {};
  try {
    const response = await api.get(
      `api/get_login_details/?register_id=${id}&fcmToken=${fcmToken.fcmToken}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
